// extracted by mini-css-extract-plugin
export default {"mazeBox":"Maze_mazeBox__S2IOQ"};